import React, { useId } from "react";
import cn from "classnames";
import AppTooltip from "../AppTooltip/AppTooltip";
import style from "./DocumentUploadSubtitle.module.scss";

const DocumentUploadSubtitle = ({ document, companyId, uploadedText, formattedType, prefix, className }) => {
  const tooltipId = useId();
  const uploaderName = companyId === document.companyId ? document.authorName : document.companyName;

  return (
    <>
      <span className={cn(className, style.subtitle)}>
        <span className={style.fixed}>
          {prefix}
          {uploadedText}
          {uploaderName ? "・" : ""}
        </span>
        {uploaderName && (
          <span className={style.name} data-tooltip-id={tooltipId}>
            {uploaderName}
          </span>
        )}
        {formattedType && <span className={style.fixed}>・{formattedType}</span>}
      </span>
      {uploaderName && (
        <AppTooltip id={tooltipId} positionStrategy="fixed" delayShow={150}>
          {uploaderName}
        </AppTooltip>
      )}
    </>
  );
};

export default DocumentUploadSubtitle;
